import { Package, PackageHost } from '../../Container';
import { inSessionProperties } from '../../canvas/EditorSession';
import { StateProperty } from '../../canvas/ExtendableStore';
import { inExportAdapter } from '../dataExport/ExportAdapter';
import { inLensAspectProvider } from '../lens/LensReflector';
import { inAtlassianCommands } from './AtlassianCommands';
import { AtlassianContext } from './AtlassianContext';
import { BindingManager } from './BindingManager';
import { JiraCardExportAdapter } from './JiraCardExports';
import { JiraCardLensAspectProvider } from './JiraCardLensAspectProvider';
import { JiraCardMechanics } from './JiraCardMechanics';
import { JiraInfo } from './JiraInfo';
import { inJiraSprintCommands } from './JiraSprintCommands';
import { JiraSprintRecordManager } from './JiraSprintRecordManager';
import { inJiraSidebarCommands } from './sidebar/JiraSidebarCommands';

export class AtlassianPackage implements Package {

    public install = (host: PackageHost) => host
        .register(AtlassianContext, 'singleton', 'startable')
        .register(BindingManager, 'singleton', 'startable')
        .register(JiraCardMechanics, 'singleton', 'startable')
        .register(JiraSprintRecordManager, 'singleton', 'startable')
        .plug(inAtlassianCommands())
        .plug(inJiraSidebarCommands())
        .plug(inJiraSprintCommands())
        .plug(inExportAdapter(JiraCardExportAdapter))
        .plug(inLensAspectProvider(JiraCardLensAspectProvider))
        .plug(inSessionProperties(StateProperty.variable(JiraInfo, JiraInfo.empty)))
        // .plug(inToolboxItems(integrationToolboxItem))
        // .plug(inTool(jiraCardTool))
        ;
}
